import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center py-20 px-4 overflow-hidden bg-[#0f172a]" data-id="element-79">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#1e1b4b] rounded-full blur-[120px] opacity-40 pointer-events-none" data-id="element-80" />

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-81">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="order-2 lg:order-1" data-id="element-82">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-8" data-id="element-83">
            Si tu cuerpo está cansado pero tu mente{' '}
            <span className="text-[#d4a574] italic" data-id="element-84">no se calla</span>, esto es
            para ti.
          </h1>

          <div className="space-y-6 text-lg text-slate-300 font-light leading-relaxed" data-id="element-85">
            <p data-id="element-86">Te acuestas cansada.</p>
            <p data-id="element-87">El cuerpo pide cama.</p>
            <p data-id="element-88">Pero tu mente… prende.</p>

            <p data-id="element-89">
              De la nada aparece la lista: dinero, pendientes, conversación que
              no tuviste, algo que dijiste raro, algo que olvidaste, lo que
              falta, lo que viene.
            </p>

            <p data-id="element-90">
              Y entonces pasa lo peor: miras el reloj, calculas cuántas horas te
              quedan… y tu ansiedad sube.
            </p>

            <p className="font-medium text-white" data-id="element-91">
              Porque no es solo no dormir.
              <br data-id="element-92" />
              Es saber que mañana igual tienes que rendir.
            </p>

            <p className="text-[#d4a574]" data-id="element-93">
              Este ebook existe para ese momento exacto.
            </p>
          </div>

          <div className="mt-10" data-id="element-94">
            <Button className="w-full md:w-auto" data-id="element-95">
              Quiero descansar esta noche —{' '}
              <span className="line-through opacity-60 mr-1" data-id="element-96">$29</span> $6.39
            </Button>
            <p className="mt-3 text-sm text-slate-500 text-center md:text-left" data-id="element-97">
              Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="order-1 lg:order-2 flex justify-center" data-id="element-98">
          <div className="relative" data-id="element-99">
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-[#d4a574] blur-[60px] opacity-20 rounded-full" data-id="element-100" />
            <img src="https://cdn.magicpatterns.com/uploads/aeyAhziRAwJZ1u7D2sXSXE/Product_1.png" alt="Reset de Ansiedad en 14 Noches Ebook en iPad" className="relative z-10 w-full max-w-md rounded-lg shadow-2xl shadow-black/50 transform rotate-1 hover:rotate-0 transition-transform duration-700" data-id="element-101" />
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-slate-500 animate-bounce" data-id="element-102">
        <ArrowDown size={24} data-id="element-103" />
      </motion.div>
    </section>;
}